import React, { useState } from 'react';
import { Polygon as GPolygon } from 'react-google-maps';
import { compose, setDisplayName, UnpackICEWP, withHandlers } from 'recompose';
import { createSelector } from 'reselect';
import * as wicket from 'wicket';
import { IMapShapeProps } from '../types';
const Wkt = wicket.Wkt;

export const serialize = (polygon: google.maps.Polygon) => {
  const wkt = new Wkt();
  wkt.fromObject(polygon);
  return wkt.write();
};
export const parse = (wellKnownText: string) => {
  const wkt = new Wkt();
  // wkt.read('POLYGON ((35 10, 45 45, 15 40, 10 20, 35 10), (20 30, 35 35, 30 20, 20 30))')
  // wkt.read('POLYGON ((35 10, 45 45, 15 40, 10 20, 35 10))')
  wkt.read(wellKnownText);
  return wkt.toObject() as google.maps.Polygon;
};
export const isEqual = (a: google.maps.Polygon, b: google.maps.Polygon) => {
  if (a.getPaths().getLength() !== b.getPaths().getLength()) {
    return false;
  }
  return a
    .getPaths()
    .getArray()
    .every((mvca, mvcaIdx) => {
      if (
        mvca.getArray().length !==
        b
          .getPaths()
          .getAt(mvcaIdx)
          .getArray().length
      ) {
        return false;
      }
      return mvca.getArray().every((l, i) =>
        l.equals(
          b
            .getPaths()
            .getAt(mvcaIdx)
            .getAt(i)
        )
      );
    });
};
export const getDefaultPolygon = (center: google.maps.LatLng, distance: number) => {
  const polygon = new google.maps.Polygon();
  polygon.setPaths([
    [
      // compute ne point
      google.maps.geometry.spherical.computeOffset(center, distance, 45),
      // compute se point
      google.maps.geometry.spherical.computeOffset(center, distance, 135),
      // compute sw point
      google.maps.geometry.spherical.computeOffset(center, distance, 225),
      // compute nw point
      google.maps.geometry.spherical.computeOffset(center, distance, 315),
    ],
  ]);
  return serialize(polygon);
};

const createCoordinatesSelector = () => {
  return createSelector([(props: IMapShapeProps) => props.zone], (zone) => {
    try {
      return {
        polygon: parse(zone.WellKnownText as string), // !!!MUTABLE!!!
        initPolygon: zone.wkt.toObject() as google.maps.Polygon,
      };
    } catch (error) {
      console.error(error);
      return {
        polygon: undefined,
        initPolygon: undefined,
      };
    }
  });
};

const handlers = () => {
  const optionsSelector = createCoordinatesSelector();
  return {
    getData: (props: IMapShapeProps) => () => {
      return optionsSelector(props);
    },
  };
};
const useHandlers = withHandlers(handlers);
type Handlers = UnpackICEWP<typeof useHandlers>;

const Polygon = compose<IMapShapeProps & Handlers, IMapShapeProps>(
  setDisplayName('Polygon'),
  useHandlers
)(({ zone, getData, onChange, onSelect, disabled }) => {
  const { polygon: initialPolygon, initPolygon } = getData();
  const [polygon] = useState(initialPolygon);
  if (!polygon || !initPolygon) {
    return null;
  }

  return (
    <GPolygon
      key={zone.Id as number}
      onClick={disabled ? undefined : onSelect}
      onMouseUp={
        disabled
          ? undefined
          : () => {
              if (!isEqual(polygon, initPolygon)) {
                onChange(serialize(polygon));
              }
            }
      }
      paths={polygon.getPaths()}
      options={zone.options}
    />
  );
});

export default Polygon;
